module.exports = __webpack_public_path__ + "static/media/qrdir-2.268e07de.png";